import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import {ImageWrapper} from '../common';

export default class ReaderDashBoard extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  static propTypes = {
    school: PropTypes.object.isRequired,
  };

  render() {
    const {
      router: {
        history: {push},
      },
    } = this.context;
    const {school} = this.props;
    return (
      <div className="dashboard">
        <div className="reader-home">
          <div className="reader-home-action">
            <Button variant="contained" color="primary" onClick={() => push('/readings')}>
              <span className="icon-151" />
              <span>Get Started</span>
            </Button>
            {school.logo && (
              <ImageWrapper width={150} height={150}>
                <img alt="Logo" src={`${process.env.SERVER_BASE_URL}${school.logo}`} />
              </ImageWrapper>
            )}
          </div>
          <div className="reader-home-message">
            <img src="/images/ralph-shadow.png" />
            <p>Hi! I'm Ralph, Welcome to our App to track student reading…</p>
          </div>
        </div>
        <div className="footer footer-with-characters">
          <div className="footer-subtext">Kluwell – creating enthusiastic readers</div>
        </div>
      </div>
    );
  }
}
